/**
 * @prettier
 */
import { debounce as debounceFunction } from 'throttle-debounce';

export function debounce(fn: any, ms: number): any {
    return debounceFunction(ms, false as any, fn); // TODO: remove false as any and pass correct type, maybe () => {} or?
}
